import { render, staticRenderFns } from "./TopChosen.vue?vue&type=template&id=2f8a3fe1&scoped=true"
import script from "./TopChosen.vue?vue&type=script&lang=js"
export * from "./TopChosen.vue?vue&type=script&lang=js"
import style0 from "./TopChosen.vue?vue&type=style&index=0&id=2f8a3fe1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8a3fe1",
  null
  
)

export default component.exports